var map = {
	"./tag-celebration.png": "+S7n",
	"./tag-new-server.png": "Wts4",
	"./tag-reservation.png": "7Zd9",
	"./tag-star-jade.png": "I9M0",
	"./tag-treasure.png": "q+2l",
	"./tag-weapon-soul.png": "Qq6B"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9Ryy";